import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatAutocompleteTrigger} from '@angular/material';
import {Observable} from 'rxjs/Observable';

import {FieldRequestParameters, RequestParameters} from '../../models/request-parameters/parameter.model';
import {UserClk} from '../../../users/users-clk/user-clk.model';
import {UsersClkService} from '../../../users/users-clk/users-clk.service';

@Component({
  selector: 'app-users-clk-autocomplete',
  templateUrl: './users-clk-autocomplete.component.html',
  styleUrls: ['./users-clk-autocomplete.component.scss']
})
export class UsersClkAutocompleteComponent implements OnInit {

  @Input() userClkFormControl: FormControl;
  @Input('placeholder') placeholder: string;
  @Output() onUserSelected: EventEmitter<UserClk> = new EventEmitter<UserClk>();

  @ViewChild('autoUsersClk') autoUsersClk: ElementRef;
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger: MatAutocompleteTrigger;

  users: Observable<any> = new Observable<any>();
  usersLoading: boolean = true;
  usersParameters: RequestParameters = new RequestParameters();

  constructor(private usersClkService: UsersClkService) {
    this.updateUsers();
  }

  ngOnInit() {
  }


  onSelectUser(event) {
    const user = event && event.option ? event.option.value : this.userClkFormControl.value;
    this.onUserSelected.emit(user);
    setTimeout(() => {
      if (this.autocompleteTrigger) {
        this.autocompleteTrigger.closePanel();
      }
    });
  }

  displayUsers (user: UserClk) {
    if (user !== null) {
      return user.username + ' -- ' + user.firstname + ' ' + user.lastname;
    }
  }

  filterUsers (filterInput: string = '') {
    if (typeof filterInput !== 'string') {
      return;
    }
    const selected = this.userClkFormControl ? this.userClkFormControl.value : null;
    if (selected && typeof selected === 'object' && filterInput === this.displayUsers(selected)) {
      return;
    }
    if (this.usersParameters.searchString !== filterInput) {
      this.usersParameters.searchString = filterInput;
      this.updateUsers();
    }
  }

  updateUsers () {
    this.usersLoading = true;
    this.users = this.usersClkService.getUsersClk(this.usersParameters)
      .map(
        (response) => {
          this.usersLoading = false;
          return response.result;
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/users-clk-autocomplete/users-clk-autocomplete.component.ts